/**
 * Legendas que o fornecedor manda no lugar da descrição da foto: dizem DE ONDE a
 * foto veio, não o que ela mostra. O hotels-api grava "Photo from google" em toda
 * foto da propriedade que vem do Google (#4359); como `alt`, isso vazava para a
 * tela quando a imagem quebrava e era o que o leitor de tela anunciava.
 * Comparadas sem caixa e sem espaços nas pontas.
 */
const PROVENANCE_CAPTIONS: ReadonlySet<string> = new Set(['photo from google']);

/** O `alt` da foto: a descrição do fornecedor quando ela descreve algo, senão o
 *  nome do quarto/hotel. Na leitura, e não na projeção, porque os blocos já
 *  persistidos carregam a legenda crua. */
export function hotelPhotoAlt(description: string | undefined, fallback: string): string {
  const caption = description?.trim();
  if (!caption || PROVENANCE_CAPTIONS.has(caption.toLowerCase())) return fallback;
  return caption;
}
